// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__ZhGuU","actions":"GroupTable_actions__1NpFW","deleteModalFooter":"GroupTable_deleteModalFooter__2bTeI"};